<template>
  <div class="app">
    <div class="mui-card">
      <div class="mui-card-content">
        <div class="mui-card-content-inner">
          累计积分
          <span class="mui-card-content-inner-right">{{ score }}</span>
        </div>
      </div>
    </div>
    <div class="mui-card">
      <mt-loadmore :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore">
        <ul class="mui-table-view">
          <li class="mui-table-view-cell mui-media" v-for="(item, key) in postList" :key="key">
            <img class="mui-media-object mui-pull-left" src="/static/images/member_integral_icon.png">
            <div class="mui-media-body">
              <div class="mui-media-body-left">
                {{ item.buildingname }}
                <p class='mui-ellipsis'>{{ item.typename }}</p>
              </div>
              <div class="mui-media-body-right">
                <span>+{{item.score}}</span>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="allLoaded" style="text-align:center;" class="data-none">没有更多数据了</div>
        <div slot="bottom" class="mint-loadmore-bottom">
          <span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }">↑</span>
          <span v-show="bottomStatus === 'loading'">
            <mt-spinner v-show="bottomStatus === 'loading'" color="#26a2ff"></mt-spinner>
          </span>
        </div>
      </mt-loadmore>
    </div>
  </div>
</template>

<script>
export default {
  name: 'integralDetail',
  data () {
    return {
      postList: [],
      score: 0,
      allLoaded: false,
      offset: 0,
      limit: 10,
      InitialLoading: true,
      bottomStatus: '',
      title:'积分详情'

    }
  },
  created () {
    this.getScoreInfo(this.offset, this.limit)
    this.getUserInfo()
    this.$emit('getTitle', this.title)
  },
  methods: {
    getScoreInfo (offset, limit) {
      let select = {
        offset: offset,
        limit: limit
      }
      this.$http.post('api/gather/getScoreInfo', select, {emulateJSON: true})
        .then(function (data) {
          if (offset !== 0) {
            for (let i = 0; i < data.body.data.list.length; i++) {
              this.postList.push(data.body.data.list[i])
            }
          } else {
            this.postList = data.body.data.list
          }

          if (data.body.data.list.length < this.limit && offset !== 0) {
            this.allLoaded = true
          }
        })
    },
    loadBottom () {
      this.handleBottomChange('loading')
      this.offset += this.limit
      this.getScoreInfo(this.offset, this.limit)
      setTimeout(() => {
        this.handleBottomChange('loadingEnd')
      }, 3000)
      this.$refs.loadmore.onBottomLoaded()
    },
    handleBottomChange (status) {
      this.bottomStatus = status
    },
    getUserInfo () {
      this.$http.post('api/gather/getUserInfo')
        .then(function (data) {
          this.score = data.body.data.list.score
        })
    }
  }
}
</script>

<style scoped lang="scss">
.app{
  margin-bottom: 60px;
}

.mint-swipe{
  height:178.5px;
  .mint-swipe-item{
    img{
      width: 100%;
    }
  }
}

.mui-card-content-inner-right{
  width: 70%;
  text-align: right;
  display: inline-block;
  font-size: 20px;
  color: #2ac845;
}

.mui-table-view{
  .mui-table-view-cell{
    .mui-media-body{
      .mui-media-body-left{
        width: 68%;
        float: left;
      }
      .mui-media-body-right{
        width: 32%;
        font-size: 18px;
        text-align: center;
        display: inline-block;
        margin-top: 14px;
        color: #2ac845;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/integralDetail.vue